import { Box } from '@mui/material'
import { t } from 'i18next'
import { SwitchField } from 'src/components/shared/ui/form/fields'
import { FormField } from 'src/enums/Form'

function OrigenCautelar(): JSX.Element {
  return (
    <Box display="flex" flexDirection="row" sx={{ marginBottom: '16px' }}>
      <SwitchField
        id={FormField.CAUTELAR}
        label={t('components.origen_cautelar.text')}
        valueOff="No"
        valueOn="Sí"
      />
    </Box>
  )
}

export default OrigenCautelar
